import { render, staticRenderFns } from "./IlluSmartphoneAcadomia.vue?vue&type=template&id=7fe2eb07&"
import script from "./IlluSmartphoneAcadomia.vue?vue&type=script&lang=js&"
export * from "./IlluSmartphoneAcadomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports